// AWS Amplify configuration
// Runtime environment detection based on hostname

// Dev configuration
const devConfig = {
  userPoolId: 'us-east-1_iv3hblXJJ',
  userPoolClientId: 'tkd2f04us4v6u2s4mabsg2bb9',
  cognitoDomain: 'dev.login.dreamjobhq.com',
  apiEndpoint: 'https://dev.api.dreamjobhq.com',
  wsEndpoint: 'wss://dev.ws.dreamjobhq.com',
  appDomain: 'dev.dreamjobhq.com',
}

// Production configuration (from env vars)
const prodConfig = {
  userPoolId: import.meta.env.VITE_USER_POOL_ID || '',
  userPoolClientId: import.meta.env.VITE_USER_POOL_CLIENT_ID || '',
  cognitoDomain: import.meta.env.VITE_COGNITO_DOMAIN || '',
  apiEndpoint: import.meta.env.VITE_API_ENDPOINT || '',
  wsEndpoint: import.meta.env.VITE_WS_ENDPOINT || '',
  appDomain: import.meta.env.VITE_APP_DOMAIN || '',
}

// Function to detect environment at runtime
function getConfig() {
  const hostname = window.location.hostname
  const isDevEnvironment = hostname.includes('dev.') || hostname.includes('localhost') || hostname === 'localhost'
  console.log('[AWS Config] Hostname:', hostname, '| isDev:', isDevEnvironment, '| Selected:', isDevEnvironment ? 'DEV' : 'PROD')
  const selected = isDevEnvironment ? devConfig : prodConfig
  console.log('[AWS Config] API Endpoint:', selected.apiEndpoint)
  return selected
}

// Get config at runtime (called when the module loads in the browser)
const config = getConfig()

export const awsConfig = {
  Auth: {
    Cognito: {
      userPoolId: config.userPoolId,
      userPoolClientId: config.userPoolClientId,
      loginWith: {
        oauth: {
          domain: config.cognitoDomain,
          scopes: ['email', 'openid', 'profile', 'aws.cognito.signin.user.admin'],
          redirectSignIn: [
            config.appDomain.includes('dev') || config.appDomain.includes('localhost')
              ? 'http://localhost:5173/callback'
              : `https://${config.appDomain}/callback`,
          ],
          redirectSignOut: [
            config.appDomain.includes('dev') || config.appDomain.includes('localhost')
              ? 'http://localhost:5173/logout'
              : `https://${config.appDomain}/logout`,
          ],
          responseType: 'code' as const,
        },
      },
    },
  },
  API: {
    REST: {
      missfit: {
        endpoint: config.apiEndpoint,
        region: 'us-east-1',
      },
    },
  },
}

export const wsEndpoint = config.wsEndpoint
